import { useEffect, useState } from "react";
import { CoreService } from "../../application/services/CoreService";
import "./body.css";


const Body = () => {
  const [content, setContent] = useState('');

  const fetchText = async () => {
    try {
      const coreService = new CoreService();

      const content = await coreService.fetchTermsAndConditions();

      setContent(content.description);
    }
    catch (error: any) {
      console.error(`[ERR0] ha ocurrido un error: ${error.message}`);
    }
    finally {
      return Promise.resolve();
    }
  }

  useEffect(() => {
    (async () => {
      console.log('[INF0] Body -- useEffect has been triggered!');

      if (content) {
        return;
      }

      await fetchText();
    })();
  }, [content]);

  return (
    <>
      <div id="body">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="document-content" dangerouslySetInnerHTML={{__html: content}}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default Body;

